import { StyleSheet } from "@react-pdf/renderer";

export const generateFinancialFileStyle = StyleSheet.create({
	page: {
		flexDirection: "column",
		backgroundColor: "#FFFFFF",
		padding: 20,
		fontFamily: "Helvetica",
	},
	header: {
		flexDirection: "row",
		alignItems: "center",
		marginBottom: 20,
		borderBottom: 3,
		borderBottomColor: "#0066CC",
		paddingBottom: 10,
	},
	logo: {
		width: 60,
		height: 60,
		marginRight: 20,
	},
	logoImage: {
		width: 150,
		height: 60,
	},
	logoText: {
		fontSize: 24,
		fontWeight: "bold",
		color: "#0066CC",
	},
	logoSubtext: {
		fontSize: 12,
		color: "#0066CC",
	},
	title: {
		fontSize: 20,
		fontWeight: "bold",
		color: "#0066CC",
		textAlign: "center",
		marginBottom: 20,
	},
	sectionContainer: {
		marginBottom: 15,
	},
	sectionHeader: {
		flexDirection: "row",
		alignItems: "center",
		marginBottom: 8,
	},
	sectionIcon: {
		width: 8,
		height: 8,
		backgroundColor: "#00CCFF",
		borderRadius: 4,
		marginRight: 8,
	},
	sectionTitle: {
		fontSize: 12,
		fontWeight: "bold",
		color: "#0066CC",
	},
	sectionContent: {
		fontSize: 10,
		color: "#333333",
		lineHeight: 1.4,
	},
	eventId: {
		backgroundColor: "#0066CC",
		color: "#FFFFFF",
		padding: 8,
		textAlign: "center",
		fontSize: 12,
		fontWeight: "bold",
		marginBottom: 15,
		textTransform: "uppercase",
	},
	tableHeader: {
		backgroundColor: "#0066CC",
		color: "#FFFFFF",
		padding: 8,
		textAlign: "center",
		fontSize: 12,
		fontWeight: "bold",
		marginTop: 20,
		marginBottom: 10,
	},
	tableContainer: {
		marginBottom: 20,
	},
	tableRow: {
		flexDirection: "row",
		borderBottomWidth: 1,
		borderBottomColor: "#CCCCCC",
		paddingVertical: 5,
		color: "#0066CC",
		fontSize: 8,
	},
	tableRowTotal: {
		fontWeight: "bold",
	},
	tableHeaderRow: {
		flexDirection: "row",
		backgroundColor: "#F0F0F0",
		paddingVertical: 2,
		fontWeight: "bold",
		color: "#0066CC",
		fontSize: 8,
	},
	tableCell: {
		flex: 1,
		paddingHorizontal: 8,
	},
	tableCellCenter: {
		flex: 1,
		paddingHorizontal: 8,
		textAlign: "center",
	},
	tableCellRight: {
		flex: 1,
		paddingHorizontal: 8,
		textAlign: "right",
	},
	totalSection: {
		marginTop: 20,
		paddingTop: 15,
		borderTopWidth: 2,
		borderTopColor: "#0066CC",
	},
	sectionInline: {
		flexDirection: "row",
		gap: 4,
		alignItems: "center",
		marginTop: 6,
	},
	label: {
		fontSize: 10,
		fontWeight: "bold",
		color: "#0066CC",
	},
	value: {
		color: "#0066CC",
		fontSize: 10,
	},
});
